/**
 * Handles the charts for the page
 */
define(['jquery', 'c21/charts/LocalAreaDataChart', 'c21/charts/LocalAreaIndexChart'], function ($, LocalAreaDataChart, LocalAreaIndexChart) {
   "use strict";

   var m_oData;
   
   function initializeHorizontalChart(jBarItems, iMinValue, iMaxValue) {
      if (iMinValue === undefined) {
         jBarItems
               .each(function(index, el) {
                  var jBar = $(el),
                     jBarContainer = jBar.parent(),
                     jBarValue = jBarContainer
                        .find('.nearbyNumber'),
                     iVal = parseInt(jBarValue.html().replace(/,/g, ''));
                  
                  if (index === 0) {
                     iMinValue = 0;
                     iMaxValue = iVal;
                  } else if (iMaxValue < iVal) {
                     iMaxValue = iVal;
                  }
               });
      }
      
      jBarItems
            .each(function(index, el) {
               var jBar = $(el),
                  jBarContainer = jBar.parent(),
                  jBarValue = jBarContainer.find('.nearbyNumber'),
                  iPercentage = (
                        parseInt(
                           jBarValue.html()
                           .replace(/,/g, '')
                        ) - iMinValue
                     ) / iMaxValue,
                  iMaxPixels = 170,
                  iMinPixels = 5,
                  iPixelPosition = ((iMaxPixels - iMinPixels) * iPercentage) + iMinPixels,
                  oCss = {
                     width: Math.round(iPixelPosition).toString() + 'px'
                  };
               
               jBar.css(oCss);
            });
   }
   
   function addCommas(strNumber) {
      return strNumber.replace(/(\d)(?=(\d{3})+$)/g, '$1,');
   }

   function setNearby(strEl, strData) {
      var str = addCommas(strData);
      $(strEl).parent().find('.nearbyNumber').html(str);
   }

   function setNearbyPercentage (strEl, strData, iDecimal) {
      var iPlaces = iDecimal || 0,
         str = parseFloat(strData).toFixed(iPlaces) + '%';

      $(strEl).parent().find('.nearbyNumber').html(str);
   }
   
   return {
      initialize : function() {
         if (m_oData) {
            setNearby('#ei01', m_oData.housing_units_vacant);
            setNearby('#ei02', m_oData.housing_units_owner_occupied);
            setNearby('#ei03', m_oData.housing_units_renter_occupied);

            // Transportation to Work
            var trwdrive = parseFloat(m_oData.transportation_car_alone_pct) +
              parseFloat(m_oData.transportation_car_carpool_pct);
            var trwpublic = parseFloat(m_oData.transportation_public_pct);
            var trwself = parseFloat(m_oData.transportation_bicycle_pct) +
              parseFloat(m_oData.transportation_walk_pct) +
              parseFloat(m_oData.transportation_other_pct);
            var trwhome = parseFloat(m_oData.transportation_work_from_home_pct);

            setNearbyPercentage('#bc01', trwdrive, 0);
            setNearbyPercentage('#bc02', trwpublic, 0);
            setNearbyPercentage('#bc03', trwself, 0);
            setNearbyPercentage('#bc04', trwhome, 0);

            if ($('#mf01').length > 0) {
               setNearbyPercentage('#mf01', m_oData.population_male_pct, 2);
               setNearbyPercentage('#mf02', m_oData.population_female_pct, 2);
            }

            if ($('#co01').length > 0) {
               setNearby('#co01', m_oData.OCCWHTCO);
               setNearby('#co02', m_oData.OCCBLUCO);
            }

            initializeHorizontalChart($('#ei01, #ei02, #ei03'));
            initializeHorizontalChart($('#bc01, #bc02, #bc03, #bc04'), 0, 100);

            if ($('#mf01').length > 0) {
               initializeHorizontalChart($('#mf01, #mf02'));
            }

            if ($('#co01').length > 0) {
               initializeHorizontalChart($('#co01, #co02'));
            }
            
            LocalAreaDataChart.initialize(m_oData);
            LocalAreaIndexChart.initialize(m_oData);
            //CrimeChart.initialize(m_oData);
            
            $(window).scroll();
         }
      },
      
      setData : function(oData) {
         m_oData = oData;
      }
   };
});
